export enum LobbyMemberTypeEnum {
  CUSTOMER = 'customer',
  TEAMMATE = 'teammate',
  MOD = 'mod',
}
